import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import TimeFormat from '@/components/TimeFormat';

const useStyles = makeStyles(theme => ({
  table: props => ({
    minWidth: props.isFinal ? 750 : 400,
  }),
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  },
}));


const SkaterBoxscore = ({ skaters, isFinal }) => {
  const classes = useStyles(isFinal);
  return (
    <TableContainer>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            {isFinal && (
              <TableCell align="right">TOI</TableCell>
            )}
            <TableCell align="right">G</TableCell>
            <TableCell align="right">A</TableCell>
            {isFinal && (
              <TableCell align="right">+/-</TableCell>
            )}
            <TableCell align="right">PIM</TableCell>
            <TableCell align="right">Shots</TableCell>
            <TableCell align="right">Hits</TableCell>
            <TableCell align="right">SB</TableCell>
            <TableCell align="right">FO</TableCell>
            {isFinal && (
              <React.Fragment>
                <TableCell align="right">PP TOI</TableCell>
                <TableCell align="right">PK TOI</TableCell>
              </React.Fragment>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          { skaters.map(skater => (
            <TableRow key={skater.id} className={classes.row}>
              <TableCell component="th" scope="row">
                {skater.name} ({skater.position})
              </TableCell>
              {isFinal && (
                <TableCell align="right">
                  <TimeFormat time={skater.toi} />
                </TableCell>
              )}
              <TableCell align="right">{skater.goals}</TableCell>
              <TableCell align="right">{skater.assists}</TableCell>
              {isFinal && (
                <TableCell align="right">{skater.plusMinus}</TableCell>
              )}
              <TableCell align="right">{skater.pims}</TableCell>
              <TableCell align="right">{skater.shots}</TableCell>
              <TableCell align="right">{skater.hits}</TableCell>
              <TableCell align="right">{skater.shotsBlocked}</TableCell>
              <TableCell align="right">{skater.faceoffsWon}/{skater.faceoffsTaken}</TableCell>
              {isFinal && (
                <React.Fragment>
                  <TableCell align="right">
                    <TimeFormat time={skater.pptoi} />
                  </TableCell>
                  <TableCell align="right">
                    <TimeFormat time={skater.pktoi} />
                  </TableCell>
                </React.Fragment>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}


export default SkaterBoxscore;